module.exports = __webpack_public_path__ + "img/sprinkle-27.3b7bed57.jpg";